import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

const FootNote = ({ content, portalId }) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (isOpen) {
      document.getElementById(portalId).classList.remove("footnote-closed")
    } else {
      document.getElementById(portalId).classList.add("footnote-closed")
    }
  }, [isOpen])

  useEffect(() => {
    const el = document.getElementById(portalId)

    el.addEventListener("click", () => {
      setIsOpen((isOpen) => !isOpen)
    })

    el.classList.add("footnote-with-javascript")
  }, [])

  return ReactDOM.createPortal(
    <svg width="16" height="16" className="footnote-icon">
      <polyline
        points="2,2 1,3 1,9 2,10 4,10 4,13 7,10 12,10 13,9 13,3 12,2 2,2"
        stroke={(isOpen) ? "black" : "grey" }
        fill={(isOpen) ? "black" : "white" }
      />
    </svg>,
    document.getElementById(portalId)
  );
};

export default FootNote;